export default __webpack_public_path__ + "static/media/img--bathroom-dark.6c46c594.jpg";